import { useTranslation } from "react-i18next";
import { UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { InputContainer } from "shared/styles/input-container-style";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { Box, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
// extraWorkAgreementNumber is known as "reference nummer" in the UI
interface Props {
  agreement?: GetExtraWorkAgreementQueryResponse;
  disabled: boolean;
}

export const Payment = (props: Props) => {
  const { t } = useTranslation();


  return (
    <InputContainer display={"flex"}>
      <Box sx={{ display: "flex" }} gap={1} flexDirection={"column"} alignItems={"flex-end"} >
        <Typography variant="caption" color={"primary.main"}>
          {t("dashboard.extraWorkAgreements.create.addPayment")}
        </Typography>


        <Typography variant="body1" display="flex" alignSelf={"flex-end"}>
          {props.agreement?.paymentDkr ?? "0"}
        </Typography>

      </Box>
    </InputContainer>
  );
};
